const var1 = 'NzFlZjJiOGVlZDRlNDYyOWNjZDY5YzQzZDljMjEwMzJhZGJhYmI5MGI1ZW';
const var2 = 'ZiMzBlZmVjMmRhZDE5MjNiODFmNQ';

export const testVar = var1 + var2;
